import { CardData, CardDiffData, CardDiffStatus } from "../card-data/card-data";
import CurrentCardElement from "./dom-elements/current-card-element";
import clone from 'just-clone';
import compare from 'just-compare';
import TargetCardElement from "./dom-elements/target-card-element";
import {UndoRedoElement, UndoStack } from "../undo-stack";

import { animate, stagger } from "motion"

// perhaps an in animation button?
const LevelStatusEnum = Object.freeze({
  'generating': 0,
  'waitingForInput': 1,
  'inAnimation': 2,
  'solved': 3,
  'cleanup': 4, // perhaps cleanup and generating could be same enum
});

export class LevelControllerV2 {
  constructor(onLevelCompleteFunc) {
    //sequenceTransformer necessary?
    this.levelStatus = LevelStatusEnum.generating;

    this.undoStack = new UndoStack();

    this.onLevelCompleteFunc = onLevelCompleteFunc;

    this.currentHandContainerEl = document.querySelector('.input-cards');

    this.playedCardContainerEl = document.querySelector('.played-card-container');

    this.targetHandContainerEl = document.querySelector('.target-sequence');

    this.trashCanForDeleted = document.querySelector('.trash-can');

    this.daFuckCan = document.querySelector('.da-fuck-can');

    this.resetBtnEl = document.querySelector('.reset-btn');

    this.undoBtnEl = document.querySelector('.undo-btn');

    this.resetBtnEl.addEventListener('click', (ev) => {
      this.resetPressed();
    });

    this.undoBtnEl.addEventListener('click', (ev) => {
      this.undoPressed();
    });

    document.onkeydown = (ev) => {
      if (this.levelStatus !== LevelStatusEnum.waitingForInput) {
        return;
      }

      const key = ev.key;

      if (key === 'r') {
        this.resetPressed();
      }
      else if ((ev.shiftKey && key === 'z')
        || key === 'y') {
        this.redoPressed();
      }
      // or ctrl or command z?
      else if (key === 'z') {
        this.undoPressed();
      }
    };
  }

  generateLevel(levelConfig, isLastLevel) {
    this.levelStatus = LevelStatusEnum.generating;

    this.startingHand = levelConfig.startingHand;

    this.currentHandData = clone(this.startingHand)

    this.targetHandInts = levelConfig.targetHandInts;

    this.currentHandElements = this.currentHandData.map((cd, i) => {
      return new CurrentCardElement(cd, this.currentHandContainerEl, this.getOnClickHandlerForIdx(i));
    });
    this.targetHandElements = this.targetHandInts.map((intVal, idx) => {

      return new TargetCardElement(intVal, this.targetHandContainerEl);
    });

    this.levelStatus = LevelStatusEnum.waitingForInput;

    // weird to have these as false?
    this.resetBtnEl.disabled = false;
    this.undoBtnEl.disabled = false;


    if (isLastLevel === true) {
      this.animateVictory();
    }
  }

  getOnClickHandlerForIdx(idx) {
    return (ev) => {
      if (this.levelStatus !== LevelStatusEnum.waitingForInput) {
        return;
      }

      const cardEl = this.currentHandElements[idx];
      //do stuff with cardEl...animate it and shit!

      const curCardData = this.currentHandData[idx];
      const cardVal = curCardData.intVal;
      const cardFunc = curCardData.cardFuncContainer.cardFunc;
      const cardDiffFunc = curCardData.cardFuncContainer.cardDiffFunc;

      // this is now the remaining cards yo
      const clonedHandData = clone(this.currentHandData);
      clonedHandData.splice(idx, 1);

      // apply this card to the cardData!

      const prevHand = clone(this.currentHandData);
      
      // todo..just have the plain ol version here?
      const applyFunc = () =>  {
        const newHandData = cardFunc(cardVal, clonedHandData);

        this.setCurrentHandInstant(newHandData)
      };

      const undoFunc = () => { this.setCurrentHandInstant(prevHand)};

      const newHandDiffs = cardDiffFunc(cardVal, clonedHandData);

      // do not allow undo redo or clicks at this point...
      // animate card being selected!
      // (move card from )


      //this.animateStuffGSAP(cardEl, idx, newHandDiffs);
      this.animateStuff(cardEl, idx, newHandDiffs).then(() => {
        // could be changed in verifyCurrentHand
        this.levelStatus = LevelStatusEnum.waitingForInput;

        const undoRedoElement = new UndoRedoElement(undoFunc, applyFunc);

        this.undoStack.addUndoRedoElement(undoRedoElement);

        // todo...check stuff!
        this.verifyCurrentHand();
      });
    }
  }

  disposeCurrentLevel() {
    this.levelStatus = LevelStatusEnum.cleanup;

    this.undoStack.clearStack();

    for (let i = 0; i < this.currentHandElements.length; i++) {
      const currentCard = this.currentHandElements[i];
      currentCard.dispose();
    }

    this.currentHandElements = [];
    this.currentHandData = [];

    for (let i = 0; i < this.targetHandElements.length; i++) {
      const targetCard = this.targetHandElements[i];
      targetCard.dispose();
    }
    this.targetHandElements = [];
  }

  // should we just get rid of carEl from currentHandElements...
  async animateStuff(playedCardEl, playedIdx, newHandDiffs) {

    this.levelStatus = LevelStatusEnum.inAnimation;

    const playedFirstRect = playedCardEl.domEl.getBoundingClientRect();

    const domElFirstRects = [];

    this.currentHandElements.splice(playedIdx, 1);

    for (let i = 0; i < this.currentHandElements.length; i++) {
      const domElI = this.currentHandElements[i].domEl;
      const firstRectI = domElI.getBoundingClientRect();

      domElFirstRects.push(firstRectI);
    }

    this.playedCardContainerEl.appendChild(playedCardEl.domEl);

    const playedLastRect = playedCardEl.domEl.getBoundingClientRect();

    const playedDeltaX = playedFirstRect.left - playedLastRect.left;
    const playedDeltaY = playedFirstRect.top - playedLastRect.top;

    playedCardEl.domEl.style.transform = `translate(${playedDeltaX}px, ${playedDeltaY}px)`;

    for (let i = 0; i < this.currentHandElements.length; i++) {
      const domElI = this.currentHandElements[i].domEl;
      const lastRectI = domElI.getBoundingClientRect();
      const firstRectI = domElFirstRects[i];

      const deltaXI = firstRectI.left - lastRectI.left;
      const deltaYI = firstRectI.top - lastRectI.top;

      domElI.style.transform =  `translate(${deltaXI}px, ${deltaYI}px)`;
    }

    // SHOULD ALSO INCLUDE card played! WEIRD THOUGH! ICKY AND GROSS
    //await animate('.input-card', {x: [null, 0], y: [null, 0]}, {duration: 0.3}).finished; // endDelay?
    await animate('.input-card', {transform: 'none'}, {duration: .3, endDelay: .15}).finished; // endDelay?

    // fade out played card! should probably have some overlap though
    await animate(playedCardEl.domEl, { scale: 1.3, opacity: 0}, {duration: .125}).finished;
    playedCardEl.dispose();

    // gross...necessary to map these firstRects to the lastRects
    // might need to have 4 arrays...
    const unchangedAnimInfos = [];
    const modifiedAnimInfos = [];
    const deletedAnimInfos = [];


    // 1. FIRST CAPTURE THE FIRST INFOS OF THE UNCHANGED AND MODIFIED AND DELETED
    // (need deleted...gunna place in some trashcan and then fade out (no transform!!))
    for (let diffIdx = 0; diffIdx < newHandDiffs.length; diffIdx++) {
      const cardDiffData = newHandDiffs[diffIdx];

      if (cardDiffData.diffStatus === CardDiffStatus.unchanged) {
        const cardEl = this.currentHandElements[cardDiffData.prevIdxOpt];

        const firstRectDiff = cardEl.domEl.getBoundingClientRect();

        unchangedAnimInfos.push({ firstRect: firstRectDiff, domEl: cardEl.domEl });

      }
      else if (cardDiffData.diffStatus === CardDiffStatus.modified) {
        const cardEl = this.currentHandElements[cardDiffData.prevIdxOpt];

        const firstRectDiff = cardEl.domEl.getBoundingClientRect();

        modifiedAnimInfos.push({ firstRect: firstRectDiff, domEl: cardEl.domEl  });
      }
      else if (cardDiffData.diffStatus === CardDiffStatus.deleted) {
        const cardEl = this.currentHandElements[cardDiffData.prevIdxOpt];

        const firstRectDiff = cardEl.domEl.getBoundingClientRect();

        // need cardEl as well, because we are gunna delete it!
        deletedAnimInfos.push({ firstRect: firstRectDiff, domEl: cardEl.domEl, cardEl: cardEl });
      }
    }

    // 2. NEXT...ADJUST THE DOM!
    // we should be able to appendChild to DOM...as we go through...hopefully
    const actualFinalHand = [];

    const addedDomEls = [];

    for (let diffIdx = 0; diffIdx < newHandDiffs.length; diffIdx++) {
      const cardDiffData = newHandDiffs[diffIdx];

      if (cardDiffData.diffStatus === CardDiffStatus.added) {
        // this should append the child!
        const cardEl = new CurrentCardElement(cardDiffData.cardData, this.currentHandContainerEl, null);

        addedDomEls.push(cardEl.domEl);

        actualFinalHand.push(cardEl);
      }
      else if (cardDiffData.diffStatus === CardDiffStatus.unchanged) {
        const cardEl = this.currentHandElements[cardDiffData.prevIdxOpt];

        this.currentHandContainerEl.appendChild(cardEl.domEl);
        actualFinalHand.push(cardEl);
      }
      else if (cardDiffData.diffStatus === CardDiffStatus.modified) {
        const cardEl = this.currentHandElements[cardDiffData.prevIdxOpt];

        cardEl.updateIntVal(cardDiffData.cardData.intVal);

        this.currentHandContainerEl.appendChild(cardEl.domEl);
        actualFinalHand.push(cardEl);
      }
      else if (cardDiffData.diffStatus === CardDiffStatus.deleted) {
        const cardEl = this.currentHandElements[cardDiffData.prevIdxOpt];

        this.trashCanForDeleted.appendChild(cardEl.domEl);
      }
    }

    // NEXT..can we do the LIP (of FLIP) separately per type?
    // also need to handle event listeners and shit

    for (let i = 0; i < addedDomEls.length; i++) {
      const domEl = addedDomEls[i];

      domEl.style.transform = 'scale(0)';
      domEl.style.opacity = 0;
    }

    for (let i = 0; i < unchangedAnimInfos.length; i++) {
      const unchangedAnimInfo = unchangedAnimInfos[i];

      const domEl = unchangedAnimInfo.domEl;

      const lastRect = domEl.getBoundingClientRect();

      const deltaX = unchangedAnimInfo.firstRect.left - lastRect.left;
      const deltaY = unchangedAnimInfo.firstRect.top - lastRect.top;

      domEl.style.transform = `translate(${deltaX}px, ${deltaY}px)`;
    }

    for (let i = 0; i < modifiedAnimInfos.length; i++) {
      const modifiedAnimInfo = modifiedAnimInfos[i];

      const domEl = modifiedAnimInfo.domEl;

      const lastRect = domEl.getBoundingClientRect();

      const deltaX = modifiedAnimInfo.firstRect.left - lastRect.left;
      const deltaY = modifiedAnimInfo.firstRect.top - lastRect.top;

      domEl.style.transform = `translate(${deltaX}px, ${deltaY}px)`;
    }


    // modifying the js curHand arrays before animations...
    // this is because of funky shit (after anims finished...they wouldn't execute...)
    this.currentHandElements = actualFinalHand;
    this.currentHandData = actualFinalHand.map(x => x.cardData);
    // adjust final hand!
    for (let i = 0; i < actualFinalHand.length; i++) {
      let cardEl = actualFinalHand[i];
      cardEl.updateOnClickHandler(this.getOnClickHandlerForIdx(i));
    }

    const animTasks = [];

    // need to dispose these...
    for (let i = 0; i < deletedAnimInfos.length; i++) {
      const deletedAnimInfo = deletedAnimInfos[i];

      const cardEl = deletedAnimInfo.cardEl;
      const domEl = deletedAnimInfo.domEl;

      const lastRect = domEl.getBoundingClientRect();

      const deltaX = deletedAnimInfo.firstRect.left - lastRect.left;
      const deltaY = deletedAnimInfo.firstRect.top - lastRect.top;

      domEl.style.transform = `translate(${deltaX}px, ${deltaY}px)`;

      const endAnimTransform = `translate(${deltaX}px, ${deltaY}px) scale(0)`;

      animTasks.push(animate(domEl, {transform: endAnimTransform, opacity: 0}, {duration: .8}));
    }

    if (addedDomEls.length > 0) {
      animTasks.push(animate(addedDomEls, {transform: 'scale(1)', opacity: 1}, {duration: .8}));
    }

    if (unchangedAnimInfos.length > 0) {
      animTasks.push(animate(unchangedAnimInfos.map(X => X.domEl),
        {transform: `none`}, {duration: .8}));
    }

    
    if (modifiedAnimInfos.length > 0) {
      // TODO HACK !!! seems as though modifiedAnims don't translate at all, so maybe I can just scale them...  
      animTasks.push(animate(modifiedAnimInfos.map(x => x.domEl),
        {transform: ['scale(1)', 'scale(1.15)', 'scale(1)'] },
        {duration: .8, offset: [0, .35]}
      ));
    }

    // this shit seems to not work fucking hell
    /*
    for (let i = 0; i < animTasks.length; i++) {
      await animTasks[i].finished;
    }
    */

    // now I gotta do this shit
    const delay = (time) => {
      return new Promise(res => {
        setTimeout(res,time)
      });
    }

    // make it match these other anims...ugh (THIS IS BECAUSE AWAIT IS NOT WORKING FOR THESE OTHER THINGS)
    await delay(800);

    for (let i = 0; i < deletedAnimInfos.length; i++) {
      const cardEl = deletedAnimInfos[i].cardEl;

      cardEl.dispose();
    }

    this.levelStatus = LevelStatusEnum.waitingForInput;
  }

  verifyCurrentHand() {
    if (this.currentHandData.length !== this.targetHandInts.length) {
      return;
    }

    let handIntsAreSame = true;
    for (let i = 0; i < this.currentHandData.length; i++) {
      // just-compare handles NaN it seems
      //if (this.currentHandData[i].intVal !== this.targetHandInts[i]) {
      if (!compare(this.currentHandData[i].intVal, this.targetHandInts[i])) {
        handIntsAreSame = false;
        break;
      }
    }

    if (handIntsAreSame) {
      this.levelStatus = LevelStatusEnum.solved;

      for (let i = 0; i < this.currentHandElements.length; i++) {
        this.currentHandElements[i].setUninteractable();
      }

      this.animateVictory()

      this.resetBtnEl.disabled = true;
      this.undoBtnEl.disabled = true;
      // perhaps this should be in charge of marking solved instead of onLevelCompleteFunc
      this.onLevelCompleteFunc();
    }
  }

  animateVictory() {
    this.targetHandElements.forEach(x => x.domEl.setAttribute('data-animation', 'solved'));

      this.winAnimation = animate('.target-seq-card', { y: [0, 30, 0] },
      {
        delay: stagger(0.15),
        duration: 1,
        repeat: Infinity,
      });
  }

  setCurrentHandInstant(newCurrentHand) {
    // copied from generate
    this.currentHandData = newCurrentHand.map(cd => new CardData(cd.intVal, cd.cardFuncContainer));

    // copied from dispose
    for (let i = 0; i < this.currentHandElements.length; i++) {
      const currentCard = this.currentHandElements[i];
      currentCard.dispose();
    }

    // copy pasta...
    this.currentHandElements = this.currentHandData.map((cd, i) => {

      return new CurrentCardElement(cd, this.currentHandContainerEl, this.getOnClickHandlerForIdx(i))

    });

  }

  resetPressed() {
    if (this.levelStatus !== LevelStatusEnum.waitingForInput) {
      return;
    }

    // noop if hands are the same
    if (compare(this.startingHand, this.currentHandData)) {
      return;
    }

    // if sequences equal...noop?

    const prevHand = clone(this.currentHandData);

    const applyFunc = () => this.setCurrentHandInstant(this.startingHand);

    const undoFunc = () => { this.setCurrentHandInstant(prevHand)};

    applyFunc();

    const undoRedoElement = new UndoRedoElement(undoFunc, applyFunc);

    this.undoStack.addUndoRedoElement(undoRedoElement);
  }

  redoPressed() {
    if (this.levelStatus !== LevelStatusEnum.waitingForInput) {
      return;
    }

    this.undoStack.tryRedo();
  }

  undoPressed() {
    if (this.levelStatus !== LevelStatusEnum.waitingForInput) {
      return;
    }

    this.undoStack.tryUndo();
  }
}